import { api } from '@api/client'
import {
  cached,
  makeKey,
  invalidate,
  TWELVE_HOURS_MS
} from '@cache/requestCache'
import { buildAnomalyUrl } from './anomaly.urls'

export function getAnomalies ({
  companyId,
  siteId = null,
  assetId = null,
  forceRefresh = false
}) {
  const url = buildAnomalyUrl({ companyId, siteId, assetId })
  const key = makeKey(url, {})
  if (forceRefresh) invalidate(key)

  return cached(
    key,
    async () => {
      const response = await api.get(url)
      return response.data
    },
    TWELVE_HOURS_MS
  )
}
